<template>
    <div
      v-loading="loading"
      class="hello"
      element-loading-text="正在绑定"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255,255,255, 0.2)"
    >
      <el-row v-if="successShow">
        <img src="../assets/apperweima.jpg">
        <h4> 绑定成功，您可以通过微信公众号订阅报警消息了。</h4>
      </el-row>
      <el-row style="text-align: center;">
        <img src="../assets/logo.png">
      </el-row>
      <el-form v-if="!successShow" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
      
        <el-form-item label="手机号码" prop="userMobile">
          <el-input  v-model="ruleForm.userMobile" />
        </el-form-item>
        <el-form-item label="登录密码" >
          <el-input v-model="ruleForm.userPassword" type="password" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">
            立即绑定
          </el-button>
          <el-button @click="resetForm('ruleForm')">
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </template>
  
  <script>
  // import webapi from '../utils/HttpApi.js'
  
  import request from '../utils/request.js'
  export default {
    name: 'openidBind',
    data() {
      var checkPhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'))
        } else {
          const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
          if (reg.test(value)) {
            callback()
          } else {
            return callback(new Error('请输入正确的手机号'))
          }
        }
      }
      return {
        loading: false,
        successShow: false,
        show: true,
        count: '',
        timer: null,
        ruleForm: {
          userMobile: "",
          userPassword:"",
          openId:''
        },
        rules: {
          userMobile: [
            { required: true, message: '请输入手机号码', trigger: 'change' },
            { validator: checkPhone, trigger: 'blur' }
          ],
          userPassword: [
            { required: true, message: '密码不能为空', trigger: 'blur' }
          ]
  
        }
      }
    },
    mounted() {
      //判断缩放是在微信中打开
      if(this.isWechat){
        console.log('页面初始化')
        console.log(this.$route.query); // 
        const pam=this.$route.query
        console.log(pam.openId)
        // 没有code 
        if(pam.openId!==undefined){
          console.log('请填写用户名和密码登录绑定')
          this.ruleForm.openId=pam.openId
        }
        // 重新拼接
        else{
          console.log('ww')
        }
      }else{
          alert('请在微信中打开') 
      }
    },
    methods: {
      submitForm(formName) {
        console.log(5)
        this.loading = true
        this.$refs[formName].validate((valid) => {
          if (valid) {
            request({
              url: '/user/bindWechat',
              method: 'post',
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              params: {
                userMobile: this.ruleForm.userMobile,
                userPassword:this.ruleForm.userPassword,
                openId:this.ruleForm.openId
              }
            }).then(res => {
              console.log(res)
            if (res.data.data === 'OK') {
                this.$message({
                  message: '绑定成功,4秒后自动返回公众号',
                  type: 'success'
                })
                this.successShow = true
                setTimeout(()=>{
                  window.opener = null;
                  window.close();
                },4000)
              } else {
                this.$message({
                  message: '绑定失败，错误消息:' + res.data.message,
                  type: 'error'
                })
              }
            })
          } else {
            return false
          }
        })
        this.loading = false
      },
      resetForm(formName) {
      this.$refs[formName].resetFields()
    },
      isWechat () {
            return String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) === 'micromessenger'
        },
      GetUrlParam() {
        var url = document.location.toString()
        var arrObj = url.split('?')
  
        if (arrObj.length > 1) {
          var arrPara = arrObj[1].split('&')
          var arr
          for (var i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split('=')
            if (arr !== null && arr[0] === 'UserCompany') {
              return arr[1]
            }
          }
          return ''
        } else {
          return ''
        }
      }
    }
  
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  h4{
    text-indent:2em;
    color: blue;
  }
  </style>
  